import {useAppState} from 'store/utils';

export function useHistoryStore(): HistoryState {
  return useAppState().history;
}
